import React, { useEffect, useMemo, useState } from "react"
import BackOfficeAPIClient from "../../clients/BackofficeAPIClient"
import { Link } from "react-router-dom"
import { FacturationActif } from "../Interfaces/Facturation/FacturationActif"

function readApiErrorMessage(err: unknown): string {
    const raw: string = err instanceof Error ? err.message : String(err)

    try {
        return JSON.parse(raw).message ?? raw
    } catch {
        return raw
    }
}

export default function InterfaceFacturation() {
    const backofficeApiClient = new BackOfficeAPIClient()

    const [ isLoading, setIsLoading ] = useState<boolean>(true)
    const [ datas, setDatas ] = useState<FacturationActif>(new FacturationActif())
    const [ error, setError ] = useState<string>("")

    useEffect(() => {
        fetchDatas()
    }, [])

    const fetchDatas = async () => {
        try {
            setIsLoading(true)
            const resultConfig = await backofficeApiClient.get<FacturationActif>("/interfaces/facturation/dashboard")
            setDatas(resultConfig)

        } catch (err: unknown) {
            setError(readApiErrorMessage(err))
        } finally {
            setIsLoading(false)
        }
    }

    const status: "many" | "one" | "none" = useMemo(() => {
        if (!datas) return "none"
        const { eDataVoiceActif, eSellerActif } = datas
        if (eDataVoiceActif && eSellerActif) return "many"
        if (eDataVoiceActif || eSellerActif) return "one"
        return "none"
    }, [ datas ])

    const backgroundCard = useMemo(() => {
        if (status === "one") return "bg-success text-white"
        if (status === "many") return "bg-warning text-black"
        return "bg-secondary text-white"
    }, [ status ])

    return (
        <div className="col-sm-3">
            <div className={`card ${isLoading ? "bg-light" : backgroundCard} mb-3`}>
                <div className="card-header">Facturation</div>
                {isLoading ?
                    <div className="card-body">
                        <h4 className="card-title">Chargement...</h4>
                        <p className="card-text text-center">
                            <i className="fa fa-spinner fa-spin fa-fw"></i>
                        </p>
                    </div>
                    :
                    error !== "" ?
                        <div className="card-body">
                            <h4 className="card-title">Erreur</h4>
                            <p className="card-text">
                                {error}
                            </p>
                        </div> :
                        status === "none" ?
                            <div className="card-body">
                                <h4 className="card-title">Désactivée</h4>
                                <Link to="interfaces/facturation" className="btn btn-sm btn-outline-dark">Paramétrage de la facturation</Link>
                            </div>
                            :
                            <div className="card-body container-fluid">
                                <div className="row text-center mb-3">
                                    {datas.eSellerActif &&
                                        <div className="col-5">
                                            <img src="./logo.png" alt="logo" className="img-fluid"/>
                                        </div>
                                    }
                                    {datas.eDataVoiceActif &&
                                        <div className="col-5">
                                            <img src="./Logo-eDataVoice.png" alt="logo" className="img-fluid"/>
                                        </div>
                                    }
                                </div>
                                <p className="card-text">
                                    <Link to="interfaces/facturation" className="btn btn-sm btn-outline-dark">Paramétrage de la facturation</Link>
                                </p>
                            </div>
                }
            </div>
        </div>
    )
}
